import { createSlice } from "@reduxjs/toolkit";
import { deleteBannerImagesAPI } from "../../actions/banners/deleteBannerImages";

const initialState = {
  addUser: {},
  loading: false,
  error: null,
};

const deleteBannerImagesSlice = createSlice({
  name: "deleteBannerImages",
  initialState,
  reducers: {
    deleteUserData: (state, action) => {
      state.addUser = action.payload.userAdded;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteBannerImagesAPI.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteBannerImagesAPI.fulfilled, (state, action) => {
        state.addUser = action.payload.bannerImageDeleted;
        state.loading = false;
      })
      .addCase(deleteBannerImagesAPI.rejected, (state, action) => {
        state.error = action.payload.error;
        state.loading = false;
      });
  },
});

export const { deleteUserData } = deleteBannerImagesSlice.actions;
export default deleteBannerImagesSlice.reducer;
